<template>
  <div>
    <div class="modal bottom-sheet" id="modalErro" ref="modal">
      <div class="modal-content">
        <div class="notification is-danger">
          <p v-for="error in errorList">
            {{error}}
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <a href="#!" @click.prevent="close()"
           class="modal-action modal-close waves-effect waves-green btn-flat">Fechar</a>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    mounted: function () {
      bus.$on('error-modal', (errors) => {
        this.errors = errors;
        this.show();
      });
    },
    watch: {
      /* errors: function (value) {
       if (value != undefined && value != {}) {
       let that = this;
       $(this.$refs.modal).modal('open',{
       complete: function() {that.errors = {} }
       });
       }
       }*/
    },
    data: () => {
      return {
        errors: {}
      }
    },
    methods: {
      show: function () {
        let that = this;

        /*
                $(this.$refs.modal).modal('open', {
                  complete: function () {
                    that.errors = {}
                  }
                });*/
        var instance = M.Modal.getInstance(this.$refs.modal);

        instance.open({
          onCloseEnd: function () {
            that.errors = {}
          }
        });
      },
      close() {
        var instance = M.Modal.getInstance(this.$refs.modal);
        instance.close();
      }
    },
    computed: {
      errorList: function () {
        let that = this;
        var list = [];
        if (that.errors) {
          if (typeof that.errors == 'object') {
            Object.keys(that.errors).forEach(function (key, index) {
              that.errors[key].forEach((error) => {
                list.push(error);
              })

            });
          } else {
            list.push('Ocorreu um erro!');
          }
        } else {
          list.push('Ocorreu um erro!');
        }
        return list;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/ErrorModal.vue